import ChatDrawerAvatarGroup from "@iso/components/ChatDrawer/ChatDrawerAvatarGroup";
import React, { useMemo } from "react";
import {SET_CONVERSATION_SELECTED} from "@iso/redux/chat/actions";
import moment from "moment";
import {CHAT_GROUP} from "@iso/components/ChatDrawer/ChatDrawer";
import {useDispatch, useSelector} from "react-redux";
import { REACT_APP_CLOUD_FRONT } from "@iso/config/config";

const MAX_SHOW_LAST_MESSAGE = 20;
const MAX_SHOW_CONVERSATION_NAME = 20;

const CONDITION_SHOW_DATE_NOW = 2;
const CONDITION_SHOW_DATE_DAYS = 2;

const getFileURL = (path) => {
  return `${REACT_APP_CLOUD_FRONT}/${path}`
}

const getAvatars = (conversation) => {
  if (!conversation?.avatar && conversation?.avatar.length <= 0) return null;

  return conversation.avatar.map(avatar => ({
    fullName: avatar?.name || '',
    avatarURL: avatar?.photos && avatar?.photos.length > 0 && avatar.photos[avatar.photos.length - 1]?.path?.origin
      ? getFileURL(avatar.photos[avatar.photos.length - 1]?.path?.origin)
      : null
  }))
}

const getMessageContent = (conversationLastMessage) => {
  if (!conversationLastMessage ||
    !conversationLastMessage?.createBy?.fullName ||
    !conversationLastMessage?.content
  ) return '';

  const msg = `${conversationLastMessage?.createBy.fullName}: ${conversationLastMessage?.content}`;

  return msg.length > MAX_SHOW_LAST_MESSAGE
    ? msg.substring(0, MAX_SHOW_LAST_MESSAGE).concat('...')
    : msg;
};

const getConversationName = ({ conversation, type }) => {
  if (!conversation || !conversation?.createBy?.fullName) return '';
  if (type === CHAT_GROUP.DIRECT) return conversation?.createBy?.fullName || '';
  if (!conversation?.match?.job?.jobName) return ''

  const convName = conversation?.match?.job?.jobName;

  return convName.length > MAX_SHOW_CONVERSATION_NAME
    ? convName.substring(0, MAX_SHOW_CONVERSATION_NAME).concat('...')
    : convName
}

const getConversationDateFormat = (createdAt) => {
  if (!createdAt) return null;

  const dateFormat = moment(createdAt);
  const diffDays = moment().diff(dateFormat, 'days');

  if (diffDays <= CONDITION_SHOW_DATE_NOW) return dateFormat.fromNow(true);
  if (diffDays <= CONDITION_SHOW_DATE_DAYS) return dateFormat.format('dddd');

  return dateFormat.format('MMMM DD');
}

const ChatDrawerSideBarItem = ({ conversation, onClick }) => {
  const dispatch = useDispatch();
  const { type, selected } = useSelector(state => state.chat);

  const conversationName = useMemo(() => {
    return getConversationName({
      conversation,
      type
    })
  }, [conversation])

  const conversationAvatars = useMemo(() => {
    return getAvatars(conversation)
  }, [conversation])

  const messageContent = useMemo(() => {
    return getMessageContent(conversation?.latestMsg)
  }, [conversation])

  const messageCreatedAt = useMemo(() => {
    return getConversationDateFormat(conversation?.activated || conversation?.created);
  }, [conversation])

  const handleSelectConversation = (conv) => {
    if (conv?._id === selected?._id) return;

    onClick && onClick(conv);

    dispatch({
      type: SET_CONVERSATION_SELECTED,
      payload: conv
    })
  }

  return (
    <div
      onClick={() => handleSelectConversation(conversation)}
      key={conversation.id}
      className={`flex p-4 gap-3 items-center ${
        conversation?._id === selected?._id ? "active" : ""
      }`}
    >
      <div className='w-p-20'>
        <ChatDrawerAvatarGroup items={conversationAvatars} defaultProfile={conversation?.createBy}/>
      </div>
      <div className="flex flex-col w-p-60">
        <strong className="text-14">{conversationName}</strong>
        <p className="text-13 mt-5">
          {messageContent}
        </p>
      </div>
      <div className='w-p-20 text-xs'>
        {messageCreatedAt}
      </div>
    </div>
  )
}

export default ChatDrawerSideBarItem;